// import logo from "./logo.svg";
import Container from "./components/Container";

function App() {
  return <Container />;
}

export default App;
